import Nav from "@/components/sections/Nav";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Clients from "@/components/sections/Clients";
import Services from "@/components/sections/Services";
import CaseStudies from "@/components/sections/CaseStudies";
import Process from "@/components/sections/Process";
import Testimonial from "@/components/sections/Testimonial";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#f4f4f5] text-[#09090b]">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Clients />
        <Services />
        <CaseStudies />
        <Process />
        <Testimonial />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
